import Dropdown, { RenderContentControls } from '@anm/components/Dropdown';
import Input from '@anm/components/form/Input';
import { FC } from 'react';

import { Label } from '../../../../StreamModalWrapper';

import { CategoryItem, ListContent } from './Wrapper';
import { useTwitchCategories } from './hooks';

export type TwitchCategoryProps = {
  selectedId?: string;
  onCategorySelect(id: string): void;
};

const TwitchCategory: FC<TwitchCategoryProps> = props => {
  const [
    categoryText,
    categories,
    isError,
    isOpenDropdown,
    handelCategoryTextChange,
    handelSelectCategory,
    openDropdown
  ] = useTwitchCategories(props);

  const showDropdown = isOpenDropdown && !!categories.length;

  const renderDropDown = showDropdown
    ? ({ isOpenContent }: RenderContentControls) =>
        isOpenContent ? (
          <ListContent>
            {categories.map(c => (
              <CategoryItem key={c.id} isSelected={c.id === props.selectedId} onClick={() => handelSelectCategory(c)}>
                {c.name}
              </CategoryItem>
            ))}
          </ListContent>
        ) : null
    : undefined;

  return (
    <Label>
      <span>Category</span>
      <Dropdown
        autoClose={false}
        openByAction="click"
        direction="to-bottom-left"
        openerVariant="default"
        renderContent={renderDropDown}
      >
        <Input
          variant="simple-small"
          placeholder="Start typing to search category"
          hasError={isError}
          value={categoryText}
          onChange={handelCategoryTextChange}
          style={{ height: 51 }}
          onClick={openDropdown}
        />
      </Dropdown>
    </Label>
  );
};

export default TwitchCategory;
